import { render, staticRenderFns } from "./RenewIcon.vue?vue&type=template&id=29ffcb46"
import script from "./RenewIcon.vue?vue&type=script&lang=js"
export * from "./RenewIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports